import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './Icon';
import './Sidebar.css';
import './ShareholderSidebar.css';
import logo from '../assets/logo.png';
import { getUserDisplayName, hasShareholderPagePermission } from '../authStorage';
import { useT } from '../i18n/translations';

const NAV_GROUPS = [
  {
    sectionKey: 'nav.home',
    items: [
      { to: '/shareholder/dashboard',  labelKey: 'common.dashboard',  icon: 'dashboard' },
    ],
  },
  {
    sectionKey: 'common.decisions',
    items: [
      { to: '/shareholder/decisions',  labelKey: 'common.decisions',  icon: 'decisions' },
      { to: '/shareholder/meetings',   labelKey: 'common.myMeetings', icon: 'calendar'  },
    ],
  },
  {
    sectionKey: 'nav.myStakeSection',
    items: [
      { to: '/shareholder/ownership',  labelKey: 'nav.myOwnership',   icon: 'money'     },
      { to: '/shareholder/dividends',  labelKey: 'nav.dividends',     icon: 'chart'     },
    ],
  },
  {
    sectionKey: 'nav.account',
    items: [
      { to: '/shareholder/users',       labelKey: 'common.users',       icon: 'user'     },
      { to: '/shareholder/permissions', labelKey: 'common.permissions', icon: 'lock'     },
      { to: '/shareholder/settings',    labelKey: 'common.settings',    icon: 'settings' },
    ],
  },
];

const MODULE_BY_ROUTE = {
  '/shareholder/dashboard':   'shareholder_dashboard',
  '/shareholder/decisions':   'shareholder_decisions',
  '/shareholder/meetings':    'shareholder_meetings',
  '/shareholder/ownership':   'shareholder_ownership',
  '/shareholder/dividends':   'shareholder_dividends',
  '/shareholder/users':       'shareholder_users',
  '/shareholder/permissions': 'shareholder_permissions',
};

const DEMO_OWNERSHIP_PCT = '18.5';

export default function ShareholderSidebar({ isOpen, onClose }) {
  const t = useT();
  const [collapsed, setCollapsed] = useState(false);
  const displayName = getUserDisplayName() || t('common.user');

  return (
    <aside className={`sidebar shareholder-sidebar${collapsed ? ' sidebar--collapsed' : ''}${isOpen ? ' sidebar--mobile-open' : ''}`}>

      <div className="sidebar__brand">
        <img src={logo} alt={t('common.brand')} className="sidebar__brand-logo" />
        <div className="sidebar__brand-text">
          <div className="sidebar__brand-name">{t('common.brand')}</div>
          <div className="sidebar__brand-tagline">{t('common.brandTagline')}</div>
        </div>
        <button type="button" className="sidebar__mobile-close" onClick={onClose} aria-label={t('common.closeMenu')}>
          <Icon name="x-circle" size={18} color="rgba(255,255,255,0.7)" />
        </button>
      </div>

      <div className="sidebar__user shareholder-sidebar__user">
        <div className="sidebar__user-avatar" style={{ background: '#02c3a6' }}>SH</div>
        <div className="sidebar__user-info">
          <div className="sidebar__user-name">{displayName}</div>
          <div className="sidebar__user-role shareholder-role-badge">
            <span className="shareholder-role-dot" />
            {DEMO_OWNERSHIP_PCT}% {t('nav.myStakeSection')}
          </div>
        </div>
        <span className="sidebar__user-dot" />
      </div>

      <nav className="sidebar__nav">
        {NAV_GROUPS.map((group) => (
          <div key={group.sectionKey}>
            <div className="sidebar__section-title">{t(group.sectionKey)}</div>
            {group.items.filter((item) => {
              const moduleId = MODULE_BY_ROUTE[item.to];
              return !moduleId || hasShareholderPagePermission(moduleId);
            }).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `sidebar__item${isActive ? ' sidebar__item--active' : ''}`}
                data-label={t(item.labelKey)}
              >
                <span className="sidebar__item-icon">
                  <Icon name={item.icon} size={18} color="rgba(255,255,255,0.85)" />
                </span>
                <span className="sidebar__item-label">{t(item.labelKey)}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <button type="button" className="sidebar__toggle" onClick={() => setCollapsed(!collapsed)}>
        <span className="sidebar__toggle-icon">
          <Icon name={collapsed ? 'chevron-right' : 'chevron-left'} size={15} color="rgba(255,255,255,0.5)" />
        </span>
        <span className="sidebar__toggle-label">{t('common.collapseMenu')}</span>
      </button>
    </aside>
  );
}
